<div *ngIf="description$ | async as description">
  <crm-collapsible-section [maxHeightPx]="300">
    <span class="description">{{ description }}</span>
  </crm-collapsible-section>
  <div *ngIf="direction$ | async as direction" class="activity-data">
    <div class="activity-data-label">
      {{ 'ACTIVITY.LOGGED_EMAIL.DIRECTION' | translate }}
    </div>
    <div class="activity-data-value">
      {{ direction === 'Sent' ? 'Outbound' : direction }}
    </div>
  </div>
</div>
